/*
  NordiskPuls NO - kundens fjern-knap paa gavelinjen
  =================================================================
  Knappen staar i snippets/cart-drawer.liquid og renderes KUN paa
  produktgaver (dem med _gavetype). Nesestrips-gaven har ingen knap:
  den styres af beloebsgraensen, og checkAutoGift() ville bare lagge
  den i igen et oejeblik senere.

  VI SLETTER IKKE LINJEN HER - OG DET ER HELE POINTEN
  Gaven er kun gratis i kraft af en ordrerabat paa kurven. Sletter man
  bare linjen, bliver rabatkoden haengende, og kunden faar 79 kr af uden
  at have en gave. Det er praecis det hul der ramte ordre #47580 i
  Danmark.
  I stedet saettes et nej paa udloeser-produktet, og np-gavemotor.js faar
  besked. Motoren fjerner saa gaven, og naar den er ude af kurven, rydder
  oprydning() rabatkoden med. Een kilde til sandhed, ingen kapkoersel.

  30 DAGE, IKKE TO TIMER
  "Nei takk" i popup'en betyder "ikke nu". At tage gaven ud af kurven
  betyder "nej tak, jeg vil ikke have den". Se np-gaveflag.js.
  Skriver hun sin mail i popup'en igen, ryddes alle nej'er.

  LYTTEREN ER DELEGERET FRA document
  Hele .drawer__inner erstattes med innerHTML ved hver kurv-opdatering.
  En lytter haengt paa selve knappen ville vaere vaek efter foerste
  gentegning - og af samme grund kan der ikke ligge en <script> i
  snippet'en.
*/
(function () {
  'use strict';

  window.npGaveFjern = function (udloeser) {
    if (!udloeser) return;
    if (!window.npGaveAfvist) return;
    window.npGaveAfvist.saet(udloeser, window.npGaveAfvist.MS_FJERNET);
    // Motoren lytter paa cart:updated (np-gavemotor.js, planlaeg()).
    document.dispatchEvent(new CustomEvent('cart:updated'));
  };

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var knap = e.target.closest('.np-gave-fjern');
    if (!knap) return;
    e.preventDefault();
    e.stopPropagation();

    // Dobbeltklik maa ikke give to nej'er og to synk-runder.
    if (knap.dataset.travlt === '1') return;
    knap.dataset.travlt = '1';

    /* Svaret skal ses MED DET SAMME. Motoren skal en tur forbi Shopify
       foer linjen faktisk forsvinder, og det tager 0,5-1,5 sek. Uden det
       her staar gaven bare stille, og kunden trykker igen. */
    var raekke = knap.closest('.cart-item');
    if (raekke) {
      raekke.style.opacity = '0.35';
      raekke.style.pointerEvents = 'none';
    }

    window.npGaveFjern(knap.dataset.gavetype);
  });
})();
